function getShippingProtectionRules() {
  const dataEl = document.getElementById('ShippingProtectionRulesData');
  if (!dataEl) return [];
  try {
    return JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Failed parsing shipping protection rules', e);
    return [];
  }
}

function findMatchingRule(subtotalCents, rules) {
  return rules.find((rule) => subtotalCents >= rule.min_cents && subtotalCents <= rule.max_cents);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.bindShippingProtectionButton();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  bindShippingProtectionButton() {
    document.addEventListener('click', (event) => {
      const btnCheckoutShipping = event.target.closest('.checkout-with-shipping-protection');
      if (!btnCheckoutShipping || btnCheckoutShipping.disabled) return;

      const rules = getShippingProtectionRules();
      if (!rules.length) {
        console.error('No shipping protection rules found');
        return;
      }

      btnCheckoutShipping.disabled = true;
      btnCheckoutShipping.classList.add('loading');

      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const protectionVariantIds = rules.map((r) => String(r.variant_id));

          const subtotalCents = cart.items.reduce((sum, item) => {
            if (protectionVariantIds.includes(String(item.variant_id))) return sum;
            return sum + item.line_price;
          }, 0);
          console.log('RULES:', rules);
          console.log('SUBTOTAL CENTS:', subtotalCents);
          const matchingRule = findMatchingRule(subtotalCents, rules);

          if (!matchingRule) {
            console.error('No matching shipping protection rule for subtotal', subtotalCents);
            btnCheckoutShipping.disabled = false;
            btnCheckoutShipping.classList.remove('loading');
            return;
          }

          const existingProtectionItem = cart.items.find((item) =>
            protectionVariantIds.includes(String(item.variant_id))
          );

          if (
            existingProtectionItem &&
            String(existingProtectionItem.variant_id) === String(matchingRule.variant_id)
          ) {
            window.location.href = '/checkout';
            return;
          }

          let removeOldTier = Promise.resolve();
          if (existingProtectionItem) {
            removeOldTier = fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: existingProtectionItem.variant_id, quantity: 0 }),
            });
          }

          return removeOldTier
            .then(() =>
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: matchingRule.variant_id, quantity: 1 }] }),
              })
            )
            .then((response) => {
              if (!response.ok) {
                return response.json().then((err) => {
                  throw new Error(err.description || 'Failed to add shipping protection to cart');
                });
              }
              return response.json();
            })
            .then(() => {
              window.location.href = '/checkout';
            });
        })
        .catch((error) => {
          console.error('Error processing shipping protection:', error);
          btnCheckoutShipping.disabled = false;
          btnCheckoutShipping.classList.remove('loading');
          alert('Gagal memproses shipping protection. Silakan coba lagi.');
        });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);